(function(root, factory) {
        root.CustomTC = factory();
}(this, function() {
